import React from 'react';

interface LogoProps {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  src,
  alt = 'Logo',
  width,
  height,
  className = '',
}) => {
  const isSvg = src.toLowerCase().endsWith('.svg');
  
  return (
    <div className={`logo-container ${className}`}>
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        style={{
          ...(isSvg ? {} : { maxWidth: '100%', height: 'auto' }),
          opacity: 0 // Start with 0 opacity for smooth fade-in
        }}
        className={`
          transition-opacity duration-300 ease-in-out
          ${isSvg ? '' : 'object-contain'}
        `}
        onLoad={(e) => {
          (e.target as HTMLImageElement).style.opacity = '1';
        }}
        onError={(e) => {
          console.error('Error loading logo:', e);
          (e.target as HTMLImageElement).style.opacity = '0';
        }}
      />
    </div>
  );
};

export default Logo;